const windowLocationReload = () => window.location.reload();

export {
  windowLocationReload,
};
